var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"adaptive-card-message message-visit-note-reason"},[_c('v-card',[_c('v-card-title',[_vm._v("Visit reason note")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.message.attributes.complaintDescription)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }